import BackendService from './BackendService';

async function getAccountHeads(params) {
  return BackendService.getData('/account-heads/', {}, params);
}

async function createAccountHead(data) {
  return BackendService.postData('/account-heads/', data);
}

async function updateAccountHead(id, data) {
  return BackendService.patch(`/account-heads/${id}/`, data);
}

async function getAccountLedger(params) {
  return BackendService.getData('/account-ledger/', {}, params);
}

async function syncAccountLedger() {
  return BackendService.postData('/account-ledger/sync/', {});
}

async function createLedgerEntry(data) {
  return BackendService.postData('/account-ledger/', data);
}

const AccountServices = {
  getAccountHeads,
  createAccountHead,
  updateAccountHead,
  getAccountLedger,
  syncAccountLedger,
  createLedgerEntry,
};

export default AccountServices;
